const ORGANIZATION_TIMEZONE_KEY = "organization_timezone";
const ORGANIZATION_SLUG_KEY = "organization_slug";

export interface OrganizationTimezone {
  timezone: string;
}

const getTimezone = (): OrganizationTimezone | null => {
  const stored = localStorage.getItem(ORGANIZATION_TIMEZONE_KEY);
  return stored ? JSON.parse(stored) : null;
};

const setTimezone = (timezone: OrganizationTimezone) =>
  localStorage.setItem(ORGANIZATION_TIMEZONE_KEY, JSON.stringify(timezone));

const resetTimezone = () => localStorage.removeItem(ORGANIZATION_TIMEZONE_KEY);

const getOrgSlug = (): string | null =>
  localStorage.getItem(ORGANIZATION_SLUG_KEY);

const setOrgSlug = (slug: string) =>
  localStorage.setItem(ORGANIZATION_SLUG_KEY, slug);

const resetOrgSlug = () => localStorage.removeItem(ORGANIZATION_SLUG_KEY);

function extractSubdomain(hostname: string): string | null {
  const slug = hostname.split(".")[0];
  if (!slug || slug === "localhost" || /^\d+$/.test(slug)) return null;
  return slug;
}


export function getSlugFromBackendUrl(): string | null {
  const explicit = import.meta.env.VITE_ORG_SLUG;
  if (explicit) return explicit;

  const slug = extractSubdomain(window.location.hostname);
  if (slug) return slug;

  try {
    const url = import.meta.env.VITE_BACKEND_URL;
    if (!url) return null;
    return extractSubdomain(new URL(url).hostname);
  } catch {
    return null;
  }
}

/**
 * The one answer to "which organization is this app talking to" (T-158).
 * Fixed order: the build's VITE_ORG_SLUG, the page's subdomain, the backend
 * URL's subdomain, and only then the cached value -- which is written from
 * those same sources, so it matters only when none of them is available.
 * The axios URL builder and the organization store both use this, so a stale
 * cache can no longer make them disagree (which produced /api/a/b/... URLs).
 */
export function resolveOrgSlug(): string | null {
  const derived = getSlugFromBackendUrl();
  if (derived) {
    if (getOrgSlug() !== derived) setOrgSlug(derived);
    return derived;
  }
  return getOrgSlug();
}

export const organizationStorage = {
  getTimezone,
  setTimezone,
  resetTimezone,
  getOrgSlug,
  setOrgSlug,
  resetOrgSlug,
};
